import { Checkbox, DropdownItem } from "@components";
import { cn } from "@utils";

const getEnumValue = (option) =>
  typeof option === "object" ? option.value : option;
const getEnumLabel = (option) =>
  typeof option === "object" ? option.label : option;

const EnumEditor = ({ value, values, onChange, disabledValues = [] }) => {
  const handleToggle = (clickedValue) => {
    if (disabledValues.includes(clickedValue)) return;
    const newValues = value.includes(clickedValue)
      ? value.filter((v) => v !== clickedValue)
      : [...value, clickedValue];
    onChange(newValues);
  };

  return values?.filter(Boolean).map((option) => {
    const optionValue = getEnumValue(option);
    const checked = value.includes(optionValue);
    const disabled = disabledValues.includes(optionValue);
    return (
      <DropdownItem
        key={optionValue}
        onClick={() => handleToggle(optionValue)}
        disabled={disabled}
      >
        <Checkbox
          readonly
          style={{ pointerEvents: "none" }}
          checked={checked}
          disabled={disabled}
        />
        <span className={cn("ml-5", disabled && "text-zinc-400")}>
          {getEnumLabel(option)}
        </span>
      </DropdownItem>
    );
  });
};

export default EnumEditor;
